import { useNavigation } from '@react-navigation/native';
import { StackNavigationProp } from '@react-navigation/stack';
import { useBreakpointValue, Flex } from 'native-base';
import React from 'react';

import { Button } from '~/components/button';
import { ContentHorizontalMargins } from '~/components/content-horizontal-margins/content-horizontal-margins';
import { HeaderProfileEditButton } from '~/components/header';
import { ProfileCard } from '~/components/profile-card';
import { ProfileCardImage } from '~/components/profile-image';
import { ContentScrollView } from '~/components/screen/content-scroll-view';
import { Spacing } from '~/components/spacing';
import { useIntl } from '~/contexts/intl';
import { useUserProfile } from '~/contexts/user-profile';
import { useExtendedNavigationHeader } from '~/hooks/navigation-header';
import { useSignOut } from '~/hooks/sign-out';
import { MainNavigatorParamList } from '~/navigator/main-navigator';

import { ProfileButtonList } from './profile-button-list';

export type ProfileNavigation = StackNavigationProp<MainNavigatorParamList, 'profile'>;

export function Profile() {
    const { navigate } = useNavigation<ProfileNavigation>();
    const { formatMessage } = useIntl();
    const signOut = useSignOut();

    const editProfileButton = <HeaderProfileEditButton onPress={() => navigate('profile-edit')} />;

    const web = useBreakpointValue({
        base: false,
        md: true
    });

    const { onScroll } = useExtendedNavigationHeader({
        headerRight: web ? <></> : editProfileButton
    });

    const profile = useUserProfile();

    return (
        <ContentScrollView
            showsVerticalScrollIndicator={false}
            onScroll={onScroll}
            bounces
            scrollEventThrottle={16}
            overScrollMode="never"
        >
            <ContentHorizontalMargins contentWidth="midsize" includePadding={false}>
                <Flex variant="standardFlexResponsive" grow="1" marginTop={{ base: '0px', md: '150px' }}>
                    <Flex direction="column">
                        <ProfileCardImage imageUrl={profile.avatarBigUrl ? profile.avatarBigUrl : undefined} />
                        {web && (
                            <Flex
                                direction="row"
                                justifyContent="center"
                                flexGrow={0}
                                flexShrink={0}
                                style={{ marginTop: 10 }}
                            >
                                {editProfileButton}
                            </Flex>
                        )}
                    </Flex>
                    <Flex flexGrow={2} marginTop={{ base: '24px', md: '0px' }}>
                        <ProfileCard {...profile} />

                        <ProfileButtonList />
                        {web && (
                            <>
                                <Spacing.Vertical.LARGE />
                                <Button
                                    fillContainer
                                    type="negative"
                                    size="regular"
                                    label={formatMessage('profile.sign-out')}
                                    onPress={signOut}
                                    style={{ maxWidth: 204, marginLeft: 16 }}
                                />
                            </>
                        )}
                    </Flex>
                </Flex>
            </ContentHorizontalMargins>
        </ContentScrollView>
    );
}
